import {
  formatterCurrency,
  formatterCurrencySemSigla,
  formatterDecimal,
} from "../../../utils/formatacaoNumeros";

type Valor = number | null | undefined;

const numero = (valor: Valor) => (typeof valor === "number" && !isNaN(valor) ? valor : 0);

export const moeda = (valor: Valor) => formatterCurrencySemSigla(numero(valor));

export const reais = (valor: Valor) => formatterCurrency(numero(valor));

export const inteiro = (valor: Valor) => formatterDecimal(Math.round(numero(valor)));

export const percentual = (valor: Valor) => `${moeda(valor)}%`;

export const percentualUmaCasa = (valor: Valor) =>
  `${numero(valor).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
